import { __decorate } from "tslib";
import { Mixins, Prop, Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import PartnershipApplicationStatusesQuery from '@/plugins/graphql/queries/v2/b2b/partnership-applications-by-status.gql';
import { PartnershipApplicationsByStatusModel } from '@/helpers/entities/models/PartnershipApplicationsByStatusModel';
import NewApplicationSubscription from '@/plugins/graphql/subscriptions/v2/application-create.gql';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
let ApplicationsManager = class ApplicationsManager extends Mixins(RouterParamsAppMixin) {
    constructor() {
        super(...arguments);
        this.selected = null;
        this.totalCount = 0;
        this.partnershipApplicationStatuses = [];
    }
};
__decorate([
    Getter('appUuid')
], ApplicationsManager.prototype, "appUuid", void 0);
__decorate([
    Prop({ type: String, default: 'pending' })
], ApplicationsManager.prototype, "status", void 0);
ApplicationsManager = __decorate([
    Component({
        apollo: {
            partnershipApplicationStatuses: {
                query: PartnershipApplicationStatusesQuery,
                variables() {
                    return {
                        appUuid: this.appUuid,
                        status: this.status,
                    };
                },
                update(data) {
                    const applicationStatutes = data.partnershipApplicationsByStatus.edges;
                    const applicationStatusNodes = (applicationStatus) => {
                        return new PartnershipApplicationsByStatusModel(applicationStatus.node);
                    };
                    this.totalCount = data.partnershipApplicationsByStatus.totalCount;
                    return applicationStatutes.map(applicationStatusNodes);
                },
                fetchPolicy: 'cache-and-network',
                subscribeToMore: {
                    document: NewApplicationSubscription,
                    variables() {
                        return {
                            appUuid: this.baseAppUUID,
                            status: this.status,
                        };
                    },
                    updateQuery: (previousResult, { subscriptionData }) => {
                        const newApplicationStatus = subscriptionData.data.applicationCreate;
                        previousResult.partnershipApplicationsByStatus.edges.unshift({
                            node: newApplicationStatus,
                            __typename: 'PartnershipApplicationEdge',
                        });
                        return previousResult;
                    },
                },
            },
        },
    })
], ApplicationsManager);
export default ApplicationsManager;
